import { spacing, color, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { baseLarge, iconBaseLarge, iconBase, base } from "./_base.js";
const classNamePrefix = "umd-action-secondary";
const secondaryBase = {
  color: color.black,
  padding: 0,
  maxWidth: "initial",
  transition: "background 0.5s ease-in-out, border 0.5s ease-in-out, color 0.5s ease-in-out",
  "&:has(svg), &:has(img)": {
    paddingLeft: `calc(${spacing.md} - 4px)`
  }
};
const secondaryBaseIcon = {
  ...iconBase,
  left: `0`,
  "& path": {
    fill: `${color.red} !important`
  }
};
const secondaryBaseLargeIcon = {
  ...iconBaseLarge,
  left: `0`,
  [`@media (${media.queries.tablet.min})`]: {
    left: `0`
  },
  "& path": {
    fill: `${color.red} !important`
  }
};
function composeSecondary(options) {
  const { size = "normal", color: buttonColor = "default" } = options || {};
  let composed = {};
  if (size === "normal") {
    composed = {
      ...base,
      ...secondaryBase
    };
  } else if (size === "large") {
    composed = {
      ...baseLarge,
      ...secondaryBase,
      "&:has(svg), &:has(img)": {
        paddingLeft: `calc(${spacing.md} - 4px)`
      },
      [`@media (${media.queries.tablet.min})`]: {
        padding: 0
      }
    };
  }
  if (buttonColor === "default") {
    composed = {
      ...composed,
      color: `${color.black}`,
      "& svg": size === "large" ? { ...secondaryBaseLargeIcon } : { ...secondaryBaseIcon }
    };
  } else if (buttonColor === "white") {
    composed = {
      ...composed,
      color: color.white,
      "& svg": size === "large" ? { ...secondaryBaseLargeIcon } : { ...secondaryBaseIcon }
    };
  } else if (buttonColor === "gold") {
    composed = {
      ...composed,
      color: color.white,
      "& svg": size === "large" ? { ...secondaryBaseLargeIcon, fill: color.gold } : { ...secondaryBaseIcon, fill: color.gold }
    };
  }
  let className = `${classNamePrefix}`;
  if (size === "large" && buttonColor === "default") {
    className = `${classNamePrefix}-large`;
  } else if (size === "normal" && buttonColor === "white") {
    className = `${classNamePrefix}-white`;
  } else if (size === "normal" && buttonColor === "gold") {
    className = `${classNamePrefix}-gold`;
  } else if (size === "large" && buttonColor === "white") {
    className = `${classNamePrefix}-large-white`;
  } else if (size === "large" && buttonColor === "gold") {
    className = `${classNamePrefix}-large-gold`;
  }
  return objectWithClassName({
    ...composed,
    className
  });
}
const normal = composeSecondary();
const large = composeSecondary({ size: "large" });
const white = composeSecondary({ color: "white" });
const gold = composeSecondary({ color: "gold" });
export {
  composeSecondary,
  gold,
  large,
  normal,
  white
};
//# sourceMappingURL=secondary.js.map
